export default "__VITE_ASSET__946fee57__"